export default __webpack_public_path__ + "static/media/logo-determined-on-light-horizontal.94ce428d.svg";